<template>
  <a-layout style="min-height: 100vh" v-if="$store.state.uncle.isSignin">
    <a-layout-sider collapsible v-model="collapsed" v-if="isPC">
      <div class="logo" :style="collapsed ? 'height: 3%' : ''" @click="$router.push('/uncle')" />
      <a-menu theme="dark" :defaultSelectedKeys="[$router.currentRoute.name]" mode="inline">
        <a-menu-item key="UncleUnprocessed" @click="$router.push('/uncle')">
          <a-badge :count="$store.state.uncle.unpending" :overflowCount="99">
            <a-icon type="team" />
            <span>접수 목록</span>
          </a-badge>
        </a-menu-item>
        <a-menu-item key="UnclePending" @click="$router.push('/uncle/pending')">
          <a-icon type="customer-service" />
          <span>사입 목록</span>
        </a-menu-item>
        <a-menu-item key="UncleSaibCompleted" @click="$router.push('/uncle/completed')">
          <a-icon type="check" />
          <span>완료된 사입</span>
        </a-menu-item>
        <a-menu-item key="UncleSaibLogs" @click="$router.push('/uncle/logs')">
          <a-icon type="solution" />
          <span>사입 로그</span>
        </a-menu-item>
        <a-menu-item key="UncleHistory" @click="$router.push('/uncle/history')">
          <a-icon type="paper-clip" />
          <span>거래 로그</span>
        </a-menu-item>
        <a-menu-item key="UncleBroadcast" @click="$router.push('/uncle/broadcast')">
          <a-icon type="schedule" />
          <span>삼촌 게시판</span>
        </a-menu-item>
        <a-menu-item key="UncleTransform" @click="$router.push('/uncle/transform')">
          <a-icon type="property-safety" />
          <span>거래 송금</span>
        </a-menu-item>
        <a-menu-item @click="uncleSignout">
          <a-icon type="logout" />
          <span>로그아웃</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-card>
        <b>이름:</b>
        {{ $store.state.uncle.username }}({{
        $store.state.uncle.identity
        }})
        <br v-if="!isPC" />
        <b>잔액:</b>
        {{ $store.state.uncle.amount.toLocaleString() }}원
        <a-button size="large" type="link" shape="circle" icon="reload" @click="uncleRefreshMe" />
        <a-radio-group v-if="!isPC" :value="$route.name">
          <a-radio-button value="UncleUnprocessed" @click="$router.push('/uncle')">
            <a-badge :count="$store.state.uncle.unpending" :overflowCount="99">접수 목록</a-badge>
          </a-radio-button>
          <a-radio-button value="UnclePending" @click="$router.push('/uncle/pending')">사입 목록</a-radio-button>
          <a-radio-button
            value="UncleSaibCompleted"
            @click="$router.push('/uncle/completed')"
          >완료된 사입</a-radio-button>
          <a-radio-button value="UncleSaibLogs" @click="$router.push('/uncle/logs')">사입 로그</a-radio-button>
          <a-radio-button value="UncleBroadcast" @click="$router.push('/uncle/broadcast')">삼촌 게시판</a-radio-button>
          <a-radio-button value="UncleTransform" @click="$router.push('/uncle/transform')">거래 송금</a-radio-button>
          <a-radio-button value="UncleHistory" @click="$router.push('/uncle/history')">거래 로그</a-radio-button>
          <a-radio-button @click="uncleSignout">로그아웃</a-radio-button>
        </a-radio-group>
      </a-card>
      <a-layout-content style="margin: 0 16px">
        <a-breadcrumb style="margin: 16px 0">
          <slot name="breadcrumb" />
        </a-breadcrumb>
        <div
          :style="{
            padding: '10px',
            background: color ? '#f0f2f5' : '#fff',
            minHeight: '360px'
          }"
        >
          <div :style="{ marginBottom: color ? '' : '30px' }">
            <p style="font-size: 150%">{{ title }}</p>
            <span style="font-size: 100%">{{ description }}</span>
          </div>
          <slot />
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">Copyright 2020. 브로 사입 all rights reserved.</a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "TheHeader",
  methods: mapActions(["uncleRefreshMe", "uncleSignout"]),

  props: ["title", "description", "color"],
  data() {
    return { collapsed: !this.isPC };
  },
  mounted() {
    this.uncleRefreshMe();
  }
};
</script>
<style>
.logo {
  height: 4.2em;
  width: auto;
  background-image: url("/assets/images/static/img_logo_type2.png");
  background-repeat: no-repeat;
  background-size: 100%;
  margin: 16px;
}
</style>
